import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Row, Col, Card, Container } from "react-bootstrap";
import { FaRocket } from "react-icons/fa";
import data from "../../Meta/Meta_ApiUrl";
import "../../assest/css/About.css";
import AboutImage from "../../assest/image/Aboutus/About/About Story Section.jpg";
import AboutMotto from "../../assest/image/Aboutus/About/Our Motto.jpg";
import AboutMission1 from "../../assest/image/Aboutus/About/Our Mission (1).jpg";
import AboutMission2 from "../../assest/image/Aboutus/About/Our Mission (2).jpg";
import AboutVision from "../../assest/image/Aboutus/About/Our Vision.jpg";
import Footer from "../Footer/Footer";
import { FaUsers, FaAward } from "react-icons/fa";
import { FaBuilding, FaProjectDiagram } from "react-icons/fa";



const About = () => {
  const [meta, setMeta] = useState({});
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 1024;

  useEffect(() => {
    // Optimized and faster AOS setup
    AOS.init({
      duration: isMobile ? 300 : 600, // faster animation time
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
      delay: isMobile ? 0 : 50, // less delay
      disable: isMobile ? "mobile" : false,
    });

    const AboutMeta = data[0]?.about_page;
    if (AboutMeta) {
      setMeta(AboutMeta);
    }

    return () => AOS.refresh();
  }, [isMobile]);

  return (
    <HelmetProvider>
      <div className="container-fluid p-0 about-container">
        <Helmet>
          <title>{meta?.title || "About Us - Aalan TechSoft"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our mission is to empower innovators to visually create, build, and automate to their true potential."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div className="about-hero" style={{ backgroundColor: "#0d47a1" }}>
          <div className="about-content text-center">
            <div className="hero-title-container">
              <span className="badge-title">About Us</span>
              <h1 className="text-white fw-bold pt-2">
                Leading the Way in IT Education and Training
              </h1>
            </div>
          </div>
        </div>

        {/* About Us Section */}
        

        <section className="about-section py-5 bg-light">
          <Container>
            <Row className="align-items-center gx-5">
              <Col
                lg={6}
                data-aos="fade-left"
                className="text-center mt-4 mt-lg-0 d-none d-lg-block "
              >
                <img
                  src={AboutImage}
                  alt="Modern education facility"
                  className="img-fluid about-image rounded-3 "
                />
              </Col>
              <Col lg={6} data-aos="fade-right">
                <h2 className="fw-bold display-5 mb-3">
                  <span className="badge-title">Our Story</span>
                </h2>
                <h2 className="fw-bold mb-4 section-title">
                  About <span style={{ color: "#85bf39" }}>Aalan TechSoft</span>
                </h2>
                <p className="section-text">
                  At Aalan TechSoft, we blend
                  professional software development with high quality tech training to help
                  learners gain both knowledge and real world experience. Our courses
                  designed to build strong, job ready skills through expert guidance and
                  practical project-based learning.
                </p>

                <p className="section-text">
                  As an active software development company, we work on live client projects,
                  giving students valuable industry exposure while improving their portfolio
                  and confidence. Aalan TechSoft is the ideal place to start and grow your
                  career in the IT industry in and around Salem.
                </p>


                <Row className="mb-4">
                  <Col md={6}>
                    <div className="d-flex align-items-center gap-3 my-3">
                      <div className="icon-container">
                        <FaBuilding className="section-icon" />
                      </div>
                      <div>
                        <div className="stats-number">8+ Years</div>
                        <div className="stats-label">Company Experience</div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="d-flex align-items-center gap-3 my-3">
                      <div className="icon-container">
                        <FaProjectDiagram className="section-icon" />
                      </div>
                      <div>
                        <div className="stats-number">100+ Projects</div>
                        <div className="stats-label"> Projects Delivered</div>
                      </div>
                    </div>
                  </Col>
                </Row>


              </Col>

            </Row>
          </Container>
        </section>

        {/* Mission & Vision Section */}
        <section key="vision" className="idea-section py-5">
          <Container>
            <Row className="g-4 align-items-center mt-4">
              <Col lg={6} data-aos="fade-right" data-aos-duration="600">
                <Card className="mission-card shadow-sm h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-4">
                      <div className="icon-circle mission-icon me-3">
                        <FaRocket size={26} />
                      </div>
                      <h3 className="card-title mb-0">Our Vision</h3>
                    </div>
                    <h2 className="section-title mb-3">Shaping the Future of Technology</h2>
                    <p className="section-text" style={{ textAlign: "justify" }}>
                      Our vision is to be a pioneering force in the tech industry, driving
                      transformative change through innovative software solutions. By staying at
                      the forefront of advancements and embracing a future-centric mindset, we aim
                      to be the go to partner for businesses seeking to unlock their full potential
                      through technology.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                lg={6}
                data-aos="fade-left"
                data-aos-duration="600"
                className="text-center"
              >
                <img
                  src={AboutVision}
                  alt="Our Vision"
                  className="img-fluid vision-image rounded shadow"
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* Mission Section */}
        <section key="mission" className="mission-section bg-light">
          <Container className="py-5 mt-5">
            <Row className="align-items-center">
              <Col lg={6}
                md={12} className="g-5 d-none d-md-block">
                <Row className="g-3">
                  <Col md={6}>
                    <img
                      src={AboutMission1}
                      alt="Working Woman"
                      className="img-fluid equal-img"
                    />
                  </Col>
                  <Col md={6} className="d-flex flex-column">
                    <img
                      src={AboutMission2}
                      alt="Meeting"
                      className="img-fluid equal-img mb-3"
                    />
                    <div className="stats-box">
                      <div className="stats-info d-flex align-items-start">
                        <i className="bi bi-globe2 fs-4 me-2"></i>
                        <span>
                          Empowering learners with industry-ready skills to build successful
                          careers.
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col
                lg={6}
                md={12}
                data-aos="fade-left"
                data-aos-duration="100"
                data-aos-delay="100"
              >
                <h2 className="section-title fw-bold display-5 mb-3">
                  <span className="badge-title">Our Mission</span>
                </h2>
                <h2 className="section-title mb-3">Cultivating Technology for a Better Future</h2>
                <p className="section-text mb-4" style={{ textAlign: "justify" }}>
                  Our mission extends beyond software development; we aspire to cultivate lasting
                  partnerships with learners and businesses alike, fostering mutual growth and
                  success. By embracing creativity, collaboration, and continuous learning, we are
                  dedicated to shaping a future where technology enriches and empowers businesses
                  and individuals across the globe.
                </p>
                <div className="d-flex gap-3 flex-wrap mt-5">
                  <div className="stats-box text-center p-3 bg-white rounded shadow flex-fill">
                    <h3 className="stats-number">20+</h3>
                    <p className="stats-subtext">Software Courses</p>
                  </div>
                  <div className="stats-box text-center p-3 bg-white rounded shadow flex-fill">
                    <h3 className="stats-number">300+</h3>
                    <p className="stats-subtext">Students Trained</p>
                  </div>
                  <div className="stats-box text-center p-3 bg-white rounded shadow flex-fill">
                    <h3 className="stats-number">100%</h3>
                    <p className="stats-subtext">Placement Guidance</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Features Section */}
        <section key="features" className="features-section py-5">
          <Container>
            <div className="text-center mb-5">
              <h2
                className="fw-bold section-title"
                data-aos="fade-down"
                // data-aos-duration="100"
                data-aos-delay="50"
              >
                Our <span style={{ color: "#85bf39" }}>Features</span>
              </h2>
              <p
                className="mb-0 section-text text-center"
                data-aos="fade-up"
                // data-aos-duration="100"
                data-aos-delay="100"
              >
                Empowering Innovation, Driving Excellence
              </p>
            </div>
            <Row className="g-4">
              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="600">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fas fa-lightbulb fs-4" style={{ color: "#85bf39" }}></i>
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Innovative Solutions</h5>
                  <p className="mb-0 card-text">
                    Learn with modern, real world solutions delivered by an experienced team of
                    experts.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="600">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fas fa-road fs-4" style={{ color: "#85bf39" }}></i>
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Tailored Learning Paths</h5>
                  <p className="mb-0 card-text">
                    Customized programs designed to match every student’s career goals and skill
                    level.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="600">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fas fa-handshake fs-4" style={{ color: "#85bf39" }}></i>
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Communication</h5>
                  <p className="mb-0 card-text">
                    Stay informed with open communication and clear guidance throughout training.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={6} lg={3} data-aos="zoom-in" data-aos-delay="100" data-aos-duration="600">
                <div className="feature-card bg-white rounded-4 shadow p-4 text-center h-100 position-relative">
                  <div
                    className="icon-wrapper bg-light mb-3 mx-auto rounded-3 d-flex justify-content-center align-items-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fas fa-chart-line fs-4" style={{ color: "#85bf39" }}></i>
                  </div>
                  <h5 className="fw-bold mb-2 card-title">Scalable Programs</h5>
                  <p className="mb-0 card-text">
                    Future ready learning programs that scale with your career and industry
                    demands.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Promotion Section */}
        <section key="promotion" className="promotion-section py-5 bg-light">
          <Container>
            <Row className="align-items-center gx-5">
              <Col
                lg={6}
                data-aos="fade-right"
                data-aos-duration="600"
                className="text-center mt-4 mt-lg-0"
              >
                <img
                  src={AboutMotto}
                  alt="Modern education facility"
                  className="img-fluid about-image rounded-3 shadow"
                />
              </Col>
              <Col lg={6} data-aos="fade-left" data-aos-delay="100">
                <h2
                  className="section-title fw-bold display-5 mb-3"
                  data-aos="fade-left"
                  data-aos-delay="100"
                >
                  <span className="badge-title">Our Motto</span>
                </h2>
                <h2
                  className="section-title mb-4"
                  data-aos="fade-left"
                  data-aos-delay="100"
                >
                  Igniting Minds, Shaping Futures at the{" "}
                  <span style={{ color: "#85bf39" }}>
                    Best Software Training Institute in Salem
                  </span>
                </h2>
                <p
                  className="section-text mb-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  style={{ textAlign: "justify" }}
                >
                  At Aalan TechSoft, we’re passionate about helping people learn the skills they
                  need to succeed in the tech world. Our goal is to provide high quality,
                  affordable training that equips you with the knowledge and tools to build a
                  rewarding career.
                </p>
                <p
                  className="section-text"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  style={{ textAlign: "justify" }}
                >
                  Join us and discover why we’re the best software training institute in Salem.
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default About;
